export default __webpack_public_path__ + "static/media/955-demand-outline.0b70edee.gif";